import React from 'react';

import { Container, TextContent, Vector, Title, AlertBox } from './styles';

import ArrowDown from '~/components/ArrowDown';

export default function Section02() {
  return (
    <>
      <Title id="conheca">
        Este ano o seu Imposto de Renda será diferente!
        <span>Faça acontecer um Projeto Social da PUC-SP!</span>
      </Title>
      <Container className="flex-wrap">
        <AlertBox className="d-none">
          <div>
            <p>
              xxx
            </p>
          </div>
        </AlertBox>
        <TextContent>
          <p>
            Nos meses de março a maio, muitas pessoas preenchem a
            Declaração Anual do Imposto de Renda. Ao completá-la, o programa da
            Receita Federal permite que você destine <b>6% do seu imposto</b>{' '}
            devido aos projetos sociais da PUC-SP, no ato da Declaração, sendo:
          </p>          
          
          <p className="highlight infos">
            <b>3% do IR para projetos voltados a crianças e adolescentes</b>
            <b className="red">+</b>
            <b>3% do IR para projetos voltados à população idosa</b>
          </p>

          <p className="highlight">
            <b>
            Quem pode destinar?
            </b>
          </p>
          <p>Contribuintes que declaram no Formulário Completo podem participar.</p>
          <p>Se você tem <b>imposto a restituir</b>, o valor destinado será SOMADO à sua restituição.</p>
          <p>Se você tiver <b>imposto a pagar</b>, o valor total destinado será ABATIDO do saldo devedor.</p>

          <p className="highlight">
            <b>
            E como calcular? 
            </b>
          </p>
          <p>Não se preocupe! O próprio programa da Receita Federal faz o cálculo automaticamente.</p>
          
          <p className="highlight">
            <b>
              Abaixo, nós apresentaremos o <span>passo a passo</span> de como
              fazer sua destinação.
            </b>
          </p>        

          
          <p className="highlight">
            <b>Então, vamos incentivar os projetos da PUC-SP?</b>
          </p>

          <p>
            Conheça abaixo os projetos aptos a receber recursos. Faça a destinação seguindo o passo a passo indicado.
          </p>
        </TextContent>
        <Vector />
        <ArrowDown toElement="projetos" className="ArrowDown" />
      </Container>
    </>
  );
}
